import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { "aria-label": "breadcrumb" }
const _hoisted_2 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_3 = { class: "cursor-pointer" }

import { computed } from 'vue';
  import { BreadcrumbType } from '@/types/BreadcrumbType';
  import router from '@/router';
  import { useI18n } from 'vue-i18n';
  import SmallButton from '@/components/widget/SmallButton.vue';
  import { useRoute } from 'vue-router';
  import { getBreadcrumbsByPath } from '@/utils/breadcrumbs';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AppBreadcrumbs',
  setup(__props) {

  const { t } = useI18n();
  const route = useRoute();

  // Dynamically compute breadcrumbs based on route's meta and params
  const computedBreadcrumbs = computed(() => {
    const breadcrumbs = getBreadcrumbsByPath(route.fullPath);

    if (breadcrumbs.length > 0) {
      return breadcrumbs;
    }
    const params = { ...route.params };
    const paramsKeys = Object.keys(params);

    // Fallback to meta if no matching template found in breadcrumbs.ts
    const metaBreadcrumbs = (route.meta.breadcrumb as BreadcrumbType[]) || [];
    const groupType = route.params.groupType;
    const groupIdentifier = route.params.groupIdentifier;
    const action = route.params.action;

    return metaBreadcrumbs.map((breadcrumb: BreadcrumbType) => {
      let updatedHref = breadcrumb.href;
      let updatedTitle = breadcrumb.title;

      if (updatedHref?.includes(':groupType')) {
        updatedHref = updatedHref.replace(':groupType', groupType as string);
      }
      if (updatedHref?.includes(':groupIdentifier')) {
        updatedHref = updatedHref.replace(':groupIdentifier', groupIdentifier as string);
      }

      if (
        updatedTitle?.includes('groupable.groupTypes') &&
        updatedTitle?.split('.')[2].includes(':')
      ) {
        updatedTitle = `groupable.groupTypes.${groupType}`;
      }
      if (updatedTitle?.includes('groupable.group.breadcrumbTitle')) {
        updatedTitle = `groupable.group.breadcrumbTitle`;
      }

      if (updatedTitle?.includes(':action')) {
        updatedTitle =
          action === 'edit'
            ? `groupable.item.form.edit.${groupType}.title`
            : `groupable.item.form.add.${groupType}.title`;
      }

      for (const key of paramsKeys) {
        updatedHref = updatedHref.replace(`:${key}`, params[key] as string);
      }

      return {
        title: updatedTitle,
        href: updatedHref,
        disabled: false, // Default for fallback
      };
    });
  });

  // Handle click on breadcrumb
  const goToBreadcrumb = (breadcrumb: BreadcrumbType) => {
    if (breadcrumb.href) {
      router.push(breadcrumb.href);
    }
  };

  // Handle 'back' button click
  const goBack = () => {
    if (window.localStorage.getItem('previousRoute')) {
      router.push(window.localStorage.getItem('previousRoute') as string);
    } else {
      router.back();
    }
  };

return (_ctx: any,_cache: any) => {
  const _component_v_breadcrumbs_item = _resolveComponent("v-breadcrumbs-item")!
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_v_row, { class: "bg-color-primary2" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "9"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_breadcrumbs, { class: "width-100" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedBreadcrumbs.value, (breadcrumb, index) => {
                  return (_openBlock(), _createBlock(_component_v_breadcrumbs_item, {
                    key: index,
                    disabled: index === computedBreadcrumbs.value.length - 1,
                    onClick: ($event: any) => (goToBreadcrumb(breadcrumb))
                  }, {
                    default: _withCtx(() => [
                      (index !== 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "/"))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)(breadcrumb.title)), 1)
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "3",
          class: "text-end pr-8",
          "align-self": "center"
        }, {
          default: _withCtx(() => [
            _createVNode(SmallButton, {
              text: "",
              brown: "",
              onClick: goBack
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { icon: "mdi-keyboard-backspace" }),
                _createTextVNode(" " + _toDisplayString(_unref(t)('breadcrumbs.back')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})